// 人脸支付接口文档地址
// http://rap2.10niu.cn/organization/repository/editor?id=21&mod=457
// 更新单个用户消费限额
// http://rap2.10niu.cn/organization/repository/editor?id=21&mod=457&itf=4085
// 卡管理接口地址：
// http://rap2.10niu.cn/organization/repository/editor?id=21&mod=463&itf=4366

import config from '@/config';
import request from '@/request/request.gateway.js';
import qs from 'qs';

export default {
	// 用户信息列表
	getUserInfoList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/user_account/v1/list`,
			params
		});
	},
	// 学校商户列表
	getSchoolAccount(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/publics/v1/get_consumption_account`,
			params
		});
	},
	// 用户信息--确认退款
	confirmRefund(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/refund`,
			data: qs.stringify(data)
		});
	},
	// 用户信息--确认取现
	confirmCashWithdrawal(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/cash`,
			data: qs.stringify(data)
		});
	},
	// 用户信息--同步余额
	postSynBalance(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/update_version`,
			data: qs.stringify(data)
		});
	},
	// 用户信息--冻结账户
	postFreezeAccount(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/disable`,
			data: qs.stringify(data)
		});
	},
	// 用户信息--解冻账户
	postUnfreezeAccount(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/enable`,
			data: qs.stringify(data)
		});
	},
	// 用户姓名列表(学生、职工)
	getUserName(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/user_account/v1/username`,
			params
		});
	},
	// 充值管理--用户信息详情
	getUserInfoDetail(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/user_account/v1/info`,
			params
		});
	},
	// 充值管理--充值接口
	postRecharge(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/charge`,
			data: qs.stringify(data)
		});
	},
	// 充值管理--充值记录
	getRechargeRecordList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/user_account/v1/charge_list`,
			params
		});
	},

	// 更新单个用户消费限额
	updateExpenseLimit(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/update_expense_limit`,
			data: qs.stringify(data)
		});
	},
	// 人脸消费_家长设置商户消费限额
	updateMerchantExpenseLimit(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/update_merchant_expense_limit`,
			data: qs.stringify(data)
		});
	},
	// 人脸消费_家长获取商户消费限额设置
	getMerchantExpenseLimit(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/user_account/v1/merchant_expense_limit`,
			params
		});
	},
	// 学校商户列表_无需角色判断
	getSchoolMerchant(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/publics/v1/get_school_account`,
			params
		});
	},
	// 人脸消费_判断设备是否有没有绑定商户
	getCheckDeviceNoBindAccount(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/user_account/v1/check_device_no_bind_account`,
			params
		});
	},
	// 人脸消费_卡管理_卡列表
	getCardList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/user_account/v1/card/list`,
			params
		});
	},
	// 人脸消费_卡管理_IC卡_换卡
	cardExchange(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/card/exchange`,
			data: qs.stringify(data)
		});
	},
	// 人脸消费_卡管理_IC卡_挂失卡
	cardMissing(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/card/missing`,
			data: qs.stringify(data)
		});
	},
	// 人脸消费_卡管理_IC卡_恢复挂失卡
	cardUnmissing(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/card/unmissing`,
			data: qs.stringify(data)
		});
	},
	// 人脸消费_卡管理_IC卡_退卡
	cardWriteOff(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/user_account/v1/card/write_off`,
			data: qs.stringify(data)
		});
	},
	// 人脸消费_号码管理_学校学生号码列表_查询
	idCardList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/id_card_manage/v1/id_card_list`,
			params
		});
	},
	getStudentIdCard(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/id_card_manage/v1/student_id_card`,
			params
		});
	},
	// 人脸消费_号码管理_学生号码_删除
	deleteStudentIdCard(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/id_card_manage/v1/delete_student_id_card`,
			params
		});
	},
	// 人脸消费_号码管理_学生号码_修改
	updateIdCard(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/id_card_manage/v1/update_id_card`,
			data: qs.stringify(data)
		});
	},
	// 批量导入学生号码信息
	batchImportIdCards(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/id_card_manage/v1/batch_import`,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json'
			}
		});
	},
	// 人脸消费_号码管理_学校职工号码列表_查询
	staffIdCardList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/id_card_manage/v1/staff_list`,
			params
		});
	},
	getStaffIdCard(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/id_card_manage/v1/staff_id_card`,
			params
		});
	},
	// 人脸消费_号码管理_职工号码_删除
	deleteStaffIdCard(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/id_card_manage/v1/delete_staff_id_card`,
			params
		});
	},
	// 人脸消费_号码管理_职工号码_修改
	updateStaffIdCard(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/id_card_manage/v1/staff_update`,
			data: qs.stringify(data)
		});
	},
	// 批量导入职工号码信息
	batchImportStaffIdCards(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/id_card_manage/v1/staff_batch_import`,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json'
			}
		});
	}
};
